// extracted by mini-css-extract-plugin
export default {"card":"Card_card__z8HfQ","header":"Card_header__0kuXG","title":"Card_title__wt3d5","full":"Card_full__h2aey"};